export default "__VITE_ASSET__Cw6GU0jX__"